import {AddressCommentTemplateIdEnum, AddressCommentTemplateType} from './address-comment-templates-type';

export const addressCommentTemplatesModalWidth = 530;

export const addressCommentTemplateList: Array<AddressCommentTemplateType> = [
    {
        id: AddressCommentTemplateIdEnum.streetSide,
        patternKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATE__STREET_SIDE__PATTERN',
        fieldList: [{name: 'street', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__STREET'}],
    },
    {
        id: AddressCommentTemplateIdEnum.courtyard,
        patternKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATE__COURTYARD__PATTERN',
        fieldList: [],
    },
    {
        id: AddressCommentTemplateIdEnum.landmark,
        patternKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATE__LANDMARK__PATTERN',
        fieldList: [{name: 'landmark', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__LANDMARK'}],
    },
    {
        id: AddressCommentTemplateIdEnum.insideBuilding,
        patternKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATE__INSIDE_BUILDING__PATTERN',
        fieldList: [
            {name: 'place', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__PLACE'},
            {name: 'floor', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__NUMBER'},
            {name: 'room', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__NUMBER'},
        ],
    },
    {
        id: AddressCommentTemplateIdEnum.buildingEnd,
        patternKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATE__BUILDING_END__PATTERN',
        fieldList: [],
    },
    {
        id: AddressCommentTemplateIdEnum.entrance,
        patternKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATE__ENTRANCE__PATTERN',
        fieldList: [{name: 'entranceType', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__ENTRANCE'}],
    },
    {
        id: AddressCommentTemplateIdEnum.territory,
        patternKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATE__TERRITORY__PATTERN',
        fieldList: [
            {name: 'objectName', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__OBJECT_NAME'},
            {name: 'gateType', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__GATE'},
        ],
    },
    {
        id: AddressCommentTemplateIdEnum.pavilion,
        patternKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATE__PAVILION__PATTERN',
        fieldList: [
            {name: 'unitNumber', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__NUMBER'},
            {name: 'row', hintKey: 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__HINT__NUMBER'},
        ],
    },
];
